import React from 'react';
import './InstructionsPopup.css';

export default function InstructionsPopup({ configValue, onClose, showCameraToggle }) {
  // Usar los mismos colores del configValue que se usan en el fondo y mensajes de status
  const backgroundColor = configValue?.styles?.backgroundColor || '#1a1a1a';
  const messageColor = configValue?.styles?.messageColor || '#ffffff';
  const messageBackgroundColor = configValue?.styles?.messageBackgroundColor || '#333333';
  const guideColor = configValue?.styles?.guideColor || '#00bcd4';

  // Color fijo para los iconos de instrucciones
  const iconBackgroundColor = configValue.styles?.instructions?.backgroundIcon || '#2B3550';
  const iconColor = '#ffffff';

  return (
    <div className="instructions-popup-overlay" style={{ backgroundColor: backgroundColor }}>
      <div className="instructions-popup" style={{ backgroundColor: messageBackgroundColor }}>
        <div className="instructions-header">
          <h2 style={{ color: messageColor }}>Instrucciones de Captura</h2>
        </div>

        <div className="instructions-content">
          <div className="instruction-item">
            <div className="instruction-icon" style={{ backgroundColor: iconBackgroundColor }}>
              <svg width="24" height="24" viewBox="0 0 188 196" xmlns="http://www.w3.org/2000/svg">
                <g transform="translate(0.000000,196.000000) scale(0.100000,-0.100000)" fill={iconColor} stroke="none">
                  <path d="M1361 1753 c-20 -80 -55 -128 -113 -157 -28 -14 -60 -26 -69 -26 -9 0 -26 -8 -38 -17 -31 -25 -12 -45 64 -67 80 -24 126 -72 149 -155 27 -98 58 -94 90 12 23 77 68 121 144 143 105 30 109 61 11 88 -86 23 -137 76 -162 164 -15 54 -20 62 -41 62 -20 0 -25 -7 -35 -47z"/>
                  <path d="M498 1440 c-255 -5 -257 -5 -282 -29 -15 -14 -31 -41 -37 -60 -7 -24 -9 -209 -7 -548 3 -499 4 -512 24 -540 11 -15 36 -36 55 -46 32 -17 72 -18 639 -15 668 4 651 2 685 68 23 44 22 561 -1 581 -11 9 -20 10 -32 2 -13 -8 -18 -29 -20 -91 l-3 -82 -109 124 c-116 132 -145 150 -193 124 -14 -7 -102 -104 -196 -215 -94 -111 -181 -209 -193 -217 -37 -26 -72 -19 -139 28 -158 111 -183 126 -210 126 -28 0 -46 -13 -160 -112 l-66 -58 -7 38 c-3 20 -6 211 -6 423 0 354 1 389 18 408 16 19 27 20 277 22 143 1 268 6 278 11 38 19 7 71 -40 66 -10 -1 -134 -5 -275 -8z"/>
                  <path d="M1013 1412 c-6 -4 -19 -26 -28 -50 -20 -48 -65 -90 -107 -99 -62 -12 -54 -61 13 -82 45 -14 77 -47 94 -97 24 -69 63 -73 83 -7 14 48 55 88 107 106 31 11 40 19 40 37 0 23 -2 25 -70 57 -31 15 -47 32 -70 78 -31 60 -41 70 -62 57z"/>
                  <path d="M1579 1205 c-12 -20 -40 -48 -61 -61 -45 -29 -47 -52 -5 -72 15 -7 35 -24 44 -38 50 -72 73 -76 98 -17 9 22 26 39 48 48 59 25 55 48 -17 98 -14 9 -31 29 -38 44 -20 41 -44 41 -69 -2z"/>
                  <path d="M474 1196 c-29 -29 -34 -41 -34 -79 0 -83 79 -142 155 -117 52 17 85 62 85 117 0 38 -5 50 -34 79 -30 30 -40 34 -86 34 -46 0 -56 -4 -86 -34z"/>
                </g>
              </svg>
            </div>
            <div className="instruction-text">
              <h3 style={{ color: messageColor }}>Cambiar Cámara</h3>
              <p style={{ color: messageColor }}>
                {showCameraToggle
                  ? "Si el documento no se ve claramente, presiona este botón para cambiar de cámara hasta obtener una mejor imagen."
                  : "Asegúrate de que el documento se vea claramente en la cámara antes de capturar."}
              </p>
            </div>
          </div>

          <div className="instruction-item">
            <div className="instruction-icon" style={{ backgroundColor: iconBackgroundColor }}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M18.3 5.71a.996.996 0 0 0-1.41 0L12 10.59 7.11 5.7A.996.996 0 1 0 5.7 7.11L10.59 12 5.7 16.89a.996.996 0 1 0 1.41 1.41L12 13.41l4.89 4.89a.996.996 0 1 0 1.41-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4z"
                  fill={iconColor}
                />
              </svg>
            </div>
            <div className="instruction-text">
              <h3 style={{ color: messageColor }}>Botón Cerrar</h3>
              <p style={{ color: messageColor }}>
                Presiona la "X" para cerrar y salir del proceso de captura en cualquier momento.
              </p>
            </div>
          </div>

          <div className="instruction-item">
            <div className="instruction-icon" style={{ backgroundColor: iconBackgroundColor }}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
                  fill={iconColor}
                />
              </svg>
            </div>
            <div className="instruction-text">
              <h3 style={{ color: messageColor }}>Buena Iluminación</h3>
              <p style={{ color: messageColor }}>
                Recuerda siempre estar en un lugar con buena iluminación para obtener la mejor calidad de captura.
              </p>
            </div>
          </div>
        </div>

        <div className="instructions-footer">
          <button
            className="instructions-close-button"
            style={{
              backgroundColor: guideColor,
              color: messageBackgroundColor,
              border: `2px solid ${messageColor}`
            }}
            onClick={onClose}
          >
            Entendido
          </button>
        </div>
      </div>
    </div>
  );
}
